<!-- atp-report.component.html -->

<div class="atp-report" *ngIf="atpReport !== undefined">
  <div style="display: flex; gap: 1rem;">
    <nz-card style="flex: 1;">
      <p><strong>Item Code:</strong> {{ atpReport.ItemCode }}</p>
    </nz-card>
    <nz-card style="flex: 1;">
      <nz-form-item>
        <nz-form-label [nzSm]="6" [nzXs]="24" [nzFor]="warehouse">{{'Warehouse'}}</nz-form-label>
        <nz-form-control [nzSm]="18" [nzXs]="24">
          <nz-select nzShowSearch nzAllowClear [name]="warehouse" nzPlaceHolder="Select a Warehouse"
            (ngModelChange)="warehouseChanged($event);" [(ngModel)]="warehouse" [ngModelOptions]="{standalone: true}"
            [nzDisabled]>
            <ng-container *ngFor="let option of warehouses">
              <nz-option [nzValue]="option.Code.toString()" [nzLabel]="option.Name">
              </nz-option>
            </ng-container>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </nz-card>
  </div>

  <nz-table [nzData]="combinedData" #atpTable nzBordered [nzFrontPagination]="false" [nzScroll]="{ y: '600px' }">
    <thead>
      <tr>
        <!-- <th>Date</th> -->
        <th>{{'Document' | locale }}</th>
        <!-- <th>Document Type</th> -->
        <!-- <th>Document Number</th> -->
        <!-- <th>Line Number</th> -->
        <th>{{'Customer/Vendor' | locale }}</th>
        <th>{{'Ref.' | locale }}</th>
        <th>{{'Document Date' | locale }}</th>
        <th>{{'Dispatch/Delivery Date' | locale }}</th>
        <th>{{'Quantity Change' | locale }}</th>
        <th>{{'Cumulative ATP Quantity' | locale }}</th>
      </tr>
      <tr>
        <td [colSpan]="6" style="text-align: center;">
          <ng-container *ngFor="let step of atpTable.data">
            <ng-container *ngIf="step.description === 'On-Hand Stock'">
              <h2>
                {{'In Stock - On Hand: ' | locale}} {{step.cumulativeQuantity}}
              </h2>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let step of atpTable.data">
        <ng-container *ngIf="step.description !== 'On-Hand Stock'">
          <td>
            <span *ngIf="step.description === 'Calculated'">
              <span *ngIf="step.quantityChange <= 0">Expected SO / Res. IN</span>
              <span *ngIf="step.quantityChange > 0">Expected PO / Transfers</span>
            </span>
            <span *ngIf="step.description !== 'Calculated'">
              <a (click)="openTargetDocument(step)">
                {{ step.description }}
              </a>
            </span>
          </td>
          <td>{{ step.cardCode }} - {{ step.cardName }}</td>
          <td>{{ step.numAtCard }}</td>
          <td>{{ step.documentDate === '0001-01-01T00:00:00' ? '' : (step.documentDate | date: dateFormat) }}</td>
          <td>{{ step.expectedDate | date: dateFormat }}</td>
          <td nz-typography [nzType]="step.quantityChange <= 0 ? 'danger' : 'success'">
            <span *ngIf="step.quantityChange != 0">
              {{ step.quantityChange | number }}
            </span>
          </td>
          <td nz-typography [nzType]="step.cumulativeQuantity <= 0 ? 'danger' : 'success'">{{ step.cumulativeQuantity | number }}</td>
        </ng-container>
      </tr>
    </tbody>
  </nz-table>
</div>
